import { useVoiceConversationHistory } from "@jugl-web/rest-api";
import { DataLoadingWrapper } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { FC, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useClientSupportPageWithSelectedConversation } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageWithSelectedConversation";
import { VoiceHistoryItem } from "./components/VoiceHistoryItem";

export const HistoryTabContent: FC = () => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const { selectedConversation } =
    useClientSupportPageWithSelectedConversation();
  const { ref: inViewRef, inView } = useInView();

  const {
    data: historyItems,
    isLoading,
    isLoadingMore,
    isError,
    isLoadingMoreError,
    hasMore,
    loadMore,
    retry,
  } = useVoiceConversationHistory({
    entityId,
    conversationId: selectedConversation.conv_id,
    pageSize: 20,
  });

  useEffect(() => {
    if (inView && hasMore && !isLoadingMore) {
      loadMore();
    }
  }, [hasMore, inView, isLoadingMore, loadMore]);

  return (
    <DataLoadingWrapper
      isError={isError}
      isLoading={isLoading}
      onRetry={retry}
      isLoadingMore={isLoadingMore}
      isLoadingMoreError={isLoadingMoreError}
    >
      <div className="flex min-h-full flex-col gap-8 px-6 py-10">
        {historyItems.map((item) => (
          <VoiceHistoryItem
            key={`${item.mediaId}-${item.insertedAt}`}
            {...item}
          />
        ))}
        {!isLoading && historyItems.length === 0 && (
          <span className="font-secondary text-sm text-grey-900">
            {t({
              id: "client-support-page.voice-history-empty",
              defaultMessage: "No call history yet",
            })}
          </span>
        )}
        {hasMore && !isLoading && !isLoadingMore && <div ref={inViewRef} />}
      </div>
    </DataLoadingWrapper>
  );
};
